import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-301" data-mp="upuiobiaxrsf">
      <div className="max-w-3xl mx-auto" data-id="element-302" data-mp="uojfodwoko2d">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#5B3FA0]" data-id="element-303" data-mp="zp7cjg7lbz4i">
          EL RESULTADO PARA VOS COMO DOCENTE
        </h2>

        <p className="text-xl mb-4 font-medium text-center" data-id="element-304" data-mp="14n8utyx6zuex">
          Con este material vas a lograr:
        </p>

        <div className="bg-green-50 rounded-2xl p-5 border border-green-200 mb-4" data-id="element-305" data-mp="7237xccetmt9">
          <ul className="space-y-2 text-xl font-bold text-gray-800" data-id="element-306" data-mp="c0efthj59n8u">
            <li className="flex items-start" data-id="element-307" data-mp="gy66y9byt5bz">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-308" data-mp="gx4rztrtvyoz" />
              <span data-id="element-309" data-mp="lq7reijae2d3">Ahorrar horas de planificación.</span>
            </li>
            <li className="flex items-start" data-id="element-310" data-mp="3kfy5y7oiqpjo">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-311" data-mp="3kf69yvr0epsv" />
              <span data-id="element-312" data-mp="3pd80u2uoftew">Tener los principales temas de ESI organizados.</span>
            </li>
            <li className="flex items-start" data-id="element-313" data-mp="y627cno6cwbw">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-314" data-mp="y8y448oadeyr" />
              <span data-id="element-315" data-mp="t8sipa8m0op4">Trabajar situaciones actuales con adolescentes.</span>
            </li>
            <li className="flex items-start" data-id="element-316" data-mp="ofpm0t8jcz4p">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-317" data-mp="jih2opbnip1v" />
              <span data-id="element-318" data-mp="jgd0cbtehy3p">Abordar temas sensibles con mayor seguridad.</span>
            </li>
            <li className="flex items-start" data-id="element-319" data-mp="fej5wl9stqbz">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-320" data-mp="ah9i1a225mq9" />
              <span data-id="element-321" data-mp="5i6aniylv4f4">Promover análisis, reflexión y pensamiento crítico.</span>
            </li>
          </ul>
        </div>

        <p className="text-2xl font-black text-center text-gray-900" data-id="element-322" data-mp="k4r6wx9p334">
          <span className="px-2 bg-[#FFFFFF]" data-id="element-323" data-mp="1zw7b289szzhb">
            Todo sin perder tiempo buscando actividades en internet.
          </span>
        </p>
      </div>
    </section>;
}